(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualDeleteEventVisitorsController', VirtualDeleteEventVisitorsController)

        VirtualDeleteEventVisitorsController.$inject = ['$uibModal', '$scope','SellerService' ,'ExpoService', 'VirtualFairService', 'AclService','CountriesNewService', 'TimezonesService','$http', 'API_BASE', '$state','toastr','$stateParams'];


    function VirtualDeleteEventVisitorsController( $uibModal, $scope, SellerService, ExpoService, VirtualFairService, AclService, CountriesNewService, TimezonesService, $http, API_BASE, $state, toastr, $stateParams) {
        var vm = this;

        vm.events                = '';
        vm.queryFlag             = false;
        vm.exhibitorName         = '';
        vm.email                 = '';
        vm.expo                  = '';
        vm.expoSelected          = '';
        vm.getByFilter           = getByFilter;
        vm.remove                = remove;
        vm.countResult           = 0;

        function activate() {
            if ($stateParams.hasOwnProperty('msg') && $stateParams.msg) {
                if ($stateParams.error) {
                    toastr.error(`${$stateParams.msg}`);
                } else {
                    toastr.success(`${$stateParams.msg}`);
                }

            }

            vm.getByFilter()
        }

        function remove(event){
            VirtualFairService.deleteEventVisitors(event.id).then(function(response){
            }).catch(function(err) {
                vm.getByFilter()
            });
        }

        function getByFilter() {
            vm.query = {};


            VirtualFairService.getDeleteEventVisitors().then(function(response){
                vm.events = response.data;
                vm.queryFlag       = true;
                vm.countResult     = Object.keys(response.data).length;
            }).catch(function(err) {

            });
        }

        activate();
    }

})();
